export type StrengthValue = 0 | 1 | 2 | 3 | 4

const hasLower = (value: string): boolean => /[a-z]/.test(value)
const hasUpper = (value: string): boolean => /[A-Z]/.test(value)
export const hasEnoughChars = (value: string): boolean => value.length >= 8
export const hasLowerUpper = (value: string): boolean =>
  hasLower(value) && hasUpper(value)
export const hasNumber = (value: string): boolean => /[0-9]/.test(value)
export const hasSpecialChar = (value: string): boolean =>
  /[^a-zA-Z0-9]/.test(value)
export const isUppercaseOrNumbers = (value = ''): boolean =>
  /^[A-Z0-9]*$/.test(value)
export const isUppercaseAndNumbers = (value = ''): boolean =>
  /^(?=.*[0-9])(?=.*[A-Z])([A-Z0-9]+)$/.test(value)
export const isPositiveNumber = (value: number): boolean => value >= 0
const criteria = [hasEnoughChars, hasLowerUpper, hasNumber, hasSpecialChar]
export const STEPS = criteria.length

export const getStrength = (value: string): StrengthValue =>
  criteria.reduce(
    (acc: StrengthValue, criterium: (val: string) => boolean) =>
      Math.min(criterium(value) ? acc + 1 : acc, STEPS) as StrengthValue,
    0
  )

export const passwordIsStrongEnough = (value = ''): boolean =>
  getStrength(value) === STEPS
